import { useState } from 'react';
import { Icon } from './Icon.js';

// Prominent invite-link panel with a copy button. Shown after a customer is created or an invite is
// re-issued. The link carries the one-time activation token — it IS the secret the owner sets their
// password with, so the copy affordance is deliberately obvious. Rendered as plain text (never
// dangerouslySetInnerHTML) so the token can't be interpreted as markup.

export function InviteLinkBox({
  url,
  expiresAt,
  smsSent,
}: {
  url: string;
  expiresAt?: string;
  smsSent?: boolean;
}): JSX.Element {
  const [copied, setCopied] = useState(false);

  async function copy(): Promise<void> {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      /* clipboard blocked — the link is selectable in the field as a fallback */
    }
  }

  return (
    <div className="card soft" style={{ padding: 20, marginTop: 4 }}>
      <div style={{ fontWeight: 600, marginBottom: 6 }}>קישור ההפעלה של הלקוח</div>
      <div style={{ color: 'var(--text-dim)', fontSize: 13.5, marginBottom: 14 }}>
        זהו הקישור שהלקוח פותח כדי לקבוע סיסמה ולהיכנס בפעם הראשונה. שלח לו אותו.
      </div>
      <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
        <input
          readOnly
          aria-label="קישור הפעלה"
          value={url}
          dir="ltr"
          onFocus={(e) => e.currentTarget.select()}
          style={{
            flex: 1, minWidth: 240, height: 44, padding: '0 14px', borderRadius: 'var(--pill)',
            border: '1px solid var(--hair)', background: 'var(--surface-2)', color: 'var(--text)',
            fontFamily: 'var(--font-mono)', fontSize: 13,
          }}
        />
        <button className="btn" type="button" onClick={copy} style={{ height: 44 }}>
          <Icon name={copied ? 'check' : 'download'} /> {copied ? 'הועתק' : 'העתק קישור'}
        </button>
      </div>
      <div style={{ display: 'flex', gap: 16, marginTop: 12, fontSize: 12.5, color: 'var(--text-dim)', flexWrap: 'wrap' }}>
        {expiresAt && <span>הקישור בתוקף עד {new Date(expiresAt).toLocaleDateString('he-IL')}</span>}
        {smsSent !== undefined && (
          <span className={`chip ${smsSent ? 'green' : 'muted'}`}>
            {smsSent ? 'נשלח גם ב-SMS' : 'לא נשלח SMS'}
          </span>
        )}
      </div>
    </div>
  );
}
